import React from "react";
import { flagLabel } from "../../tools/langs";

type Props = {
  lang: string;
  className?: string;
};
const LangDisplay: React.FC<Props> = ({ lang, className }) => {
  return <div className={className}>{flagLabel(lang)}</div>;
};

export default LangDisplay;
